import { FieldsOptions } from '@sim/form';
import { dateValidator } from '@sim/form/validators';

import { Attachment, AttachmentMeta } from './attachament';

export interface Restoration {
  allegati: Attachment[];
  dataFine: string;
  dataInizio: string;
  descrizione: string;
  esecutore: string;
}

export const RestorationMeta: FieldsOptions<Restoration> = {
  allegati: { type: 'array', controls: AttachmentMeta, value: [] },
  dataFine: { validators: [dateValidator()] },
  dataInizio: { validators: [dateValidator()] },
  descrizione: {},
  esecutore: {},
};
